export const normalizeImages = (value) => {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);

    if (Array.isArray(parsed)) {
      return parsed;
    }

    if (typeof parsed === "string") {
      return [parsed];
    }

    return [];
  } catch {
    // If it's not valid JSON but is a plain string URL
    if (typeof value === "string") return [value];

    return [];
  }
};
